import { Injectable } from '@angular/core';
import { FirebaseApp } from 'angularfire2';
import { Http, RequestOptionsArgs, Headers, RequestOptions } from "@angular/http";
import 'rxjs/add/operator/toPromise';

@Injectable()
export class PublicService {

  public progress: number = 0;

  constructor(
    public firebaseApp: FirebaseApp,
    public http: Http
  ) { }

  /*
  上傳檔案至firebase storage

  file(必要):檔案
  folder(必要):storage的目錄
  filename(可選):上傳後的檔案名稱
   */
  uploadFile(file: File, folder: string, filename?: string, ): Promise<{}> {
    return new Promise((res, rej) => {
      let fileNmae = filename ? filename : Date.now().toString() + '-' + file.name;
      let uploadTask = this.firebaseApp.storage().ref(`/${folder}/${fileNmae}`).put(file);
      uploadTask.on('state_changed', (snapshot) => {
        this.progress = parseFloat((new Number((snapshot.bytesTransferred / snapshot.totalBytes) * 100)).toFixed(2));
      }, (error) => {
        rej(error);
      }, () => {
        res(uploadTask.snapshot.downloadURL);
      });
    });
  }

  /**
   * 移除storage中的檔案
   * @param path 檔案路徑
   */
  removeFile(path: string) {
    return Promise.resolve(this.firebaseApp.storage().ref().child(path).delete());
  }

  /**
   * 移除html tag
   * @param strText
   */
  RemoveHtmlTag(strText) {
    var regEx = /<[^>]*>/g;
    return strText.replace(regEx, "");
  }


  decodeHtml(strText) {
    if (!strText) return;
    let txt = document.createElement("textarea");
    txt.innerHTML = strText;
    return txt.value;
  }

  /**
   * 向左補0
   * @param str
   * @param lenght
   */
  padLeft(str: string, lenght: number) {
    if (str.length >= lenght)
      return str;
    else
      return this.padLeft("0" + str, lenght);
  }

  /**
   * ajax方法
   * @param url
   * @param data
   */
  ajaxPost(url: string, data: any) {
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
    let options = new RequestOptions({ headers: headers });
    let urlSearchParams = new URLSearchParams();

    for (let name in data) {
      urlSearchParams.set(name, data[name]);
    }

    return this.http.post(url, urlSearchParams.toString(), options).toPromise();
  }

  /**
   * ajax方法
   * @param url
   * @param data
   */
  ajaxPostFile(url: string, data: any) {
    let formData = new FormData();
    for (let name in data) {
      formData.append(name, data[name]);
    }
    return this.http.post(url, formData).toPromise();
  }


  /**
   *  下載 excel
   * @param fileName
   * @param sheets
   */
  async downloadXlsxV2(fileName: string, sheets: { name: string; header: string[]; data: string[][]; width?: number[] }[]) {
    const apiUrl = `https://internal-api.aiii.ai/label/generate-xlsx`;
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        fileName,
        sheets,
      }),
    });
    if (!response.ok) {
      throw new Error('API response was not ok.');
    }
    const blob = await response.blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

}



// WEBPACK FOOTER //
// ./src/app/public/public.service.ts